import { jsx as _jsx } from "react/jsx-runtime";
import DeviceImportCard from '../Cards/DeviceImportCard';
function DeviceImportView(props) {
    const { contextCustomer, user } = props;
    return _jsx("div", { children: contextCustomer && user && _jsx(DeviceImportCard, { ...props }) });
}
export default DeviceImportView;
